/* eslint-disable */
import React, { Component } from 'react';
import propTypes from 'prop-types';

import classes from './ActionsItem.css';

class ActionsItem extends Component {
  render () {
    let picture = ".";
    if(this.props.pictureUser) {
        picture = this.props.pictureUser;
    }
    return (
    <div className={[classes.Card, 'row'].join(' ')}>

      { /** Action image */}
      <div className={['col-2', 'd-flex', 'align-items-center'].join(' ')}>
        <img
          src={require(`../../../assets/ic/${this.props.icAction}`)}
          className={[classes.ActionImage, 'img-responsive'].join(' ')}
          alt="action"
          title="action"
        />
      </div>
      { /** Description */}
      <div className={['col-7', 'd-flex', 'align-items-center'].join(' ')}>
        <p className={classes.actionParagraph}>
          {this.props.action}
        </p>
      </div>
      { /** User image */}
      {
      picture[0] === '.' 
        ? (
          <div className="col-3">
            <img
              src={require('../../../assets/svg/anon-user.svg')}
              className={[classes.SongImageAnon, 'img-responsive'].join(' ')}
              alt="User"
              title="User"
            />
          </div>
        ) : (
          <div className="col-3 align-self-center">
            <img
              src={picture}
              className={[classes.SongImage, 'img-responsive'].join(' ')}
              alt="User"
              title="User"
            />
          </div>
        )
      }
    </div>
  );
    }
};


export default ActionsItem;
